/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Service from 'parts/Service';
import Solutions from 'parts/Solutions';
import EnterpriseSupport from 'parts/EnterpriseSupport';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import Button from 'elements/Button';

import Data from 'json/landingPage.json';

export default class ServicesPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header {...this.props} />
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-theme-purple/5 rounded-full blur-3xl transform translate-x-1/4 -translate-y-1/4" />
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-dark-theme-purple/5 rounded-full blur-3xl transform -translate-x-1/4 translate-y-1/4" />

          <div className="container mx-auto px-4 relative z-10">
            <Fade bottom>
              <div className="text-center mb-12">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-2xl mb-6">
                  <svg className="w-10 h-10 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                  Our Services
                </h1>
                <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                  Unlock a world of opportunities for your business with our comprehensive
                  range of services, tailored to transform your business in the digital age.
                </p>
                <div className="text-center">
                  <Button
                    href="/discuss-project"
                    type="link"
                    className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105"
                  >
                    Get Quote Now
                    <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Button>
                </div>
              </div>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <div className="text-center mb-12">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-xl mb-4">
                  <svg className="w-8 h-8 text-theme-purple" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h2 className="text-3xl lg:text-4xl text-theme-blue font-bold mb-4">
                  Technical Excellence
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Delivering Scalable and Reliable Solutions
                </p>
              </div>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                What Do We Offer?
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-4xl mx-auto">
                At the core of our service offerings lies expertly crafted software solutions
                that drive your business forward. From UI/UX Design To Custom Application
                Development, From Maintenance & Support To Technology Migration, We&apos;ve got
                everything for your unique business needs.
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-3xl lg:text-4xl text-theme-blue text-center font-bold mb-12">
                Solutions
              </h2>
            </Fade>
            <Solutions data={Data.solutions} />
          </div>
        </section>

        <div className="pt-0 pb-16 bg-gray-50">
          <Service data={Data.service} />
        </div>

        <EnterpriseSupport data={Data.enterpriseSupport} />
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
